import React, { useEffect, useState } from 'react';
import { backupAPI } from '../services/api';
import DataTable from '../components/DataTable';

const JOB_COLS = [
  { key: 'customer_name',    label: 'Cliente' },
  { key: 'job_name',         label: 'Job' },
  { key: 'vm_name',          label: 'VM' },
  { key: 'repository',       label: 'Repository' },
  { key: 'backup_type',      label: 'Tipo' },
  { key: 'duration_minutes', label: 'Durata (min)' },
  { key: 'end_time',         label: 'Ultimo Run' },
  { key: 'had_retry',        label: 'Retry' },
  { key: 'status',           label: 'Stato' },
];

const VM_COLS = [
  { key: 'customer_name', label: 'Cliente' },
  { key: 'job_name',      label: 'Job' },
  { key: 'vm_name',       label: 'VM' },
  { key: 'repository',    label: 'Repository' },
  { key: 'backup_type',   label: 'Tipo' },
  { key: 'end_time',      label: 'Data' },
  { key: 'status',        label: 'Stato' },
];

const SIMPLE_COLS = [
  { key: 'customer_name', label: 'Cliente' },
  { key: 'job_name',      label: 'Job' },
  { key: 'repository',    label: 'Repository' },
  { key: 'backup_type',   label: 'Tipo' },
  { key: 'end_time',      label: 'Ultimo Run' },
  { key: 'status',        label: 'Stato' },
];

export default function OperationsPage({ customer }) {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    backupAPI.getOperations(customer)
      .then(r => setData(r.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [customer]);

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>Caricamento...</div>;
  if (!data)   return <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>Errore caricamento dati</div>;

  return (
    <div>
      <h2 style={{ margin: '0 0 20px', fontSize: 22, fontWeight: 700, color: '#1e293b' }}>Operations</h2>

      <DataTable
        title={`📋 Ultimo stato per Job — ${data.last_per_job?.length ?? 0} job`}
        columns={JOB_COLS}
        rows={data.last_per_job}
        emptyMsg="Nessun job trovato"
      />

      <DataTable
        title={`⛔ VM FAILED nell'ultimo ciclo — ${data.vm_failed?.length ?? 0}`}
        columns={VM_COLS}
        rows={data.vm_failed}
        emptyMsg="Nessuna VM FAILED ✅"
      />

      <DataTable
        title={`✅ VM OK nell'ultimo ciclo — ${data.vm_ok?.length ?? 0}`}
        columns={VM_COLS}
        rows={data.vm_ok}
        emptyMsg="Nessuna VM OK"
      />

      <DataTable
        title={`⚠️ Job con Warning attivi — ${data.warnings?.length ?? 0}`}
        columns={SIMPLE_COLS}
        rows={data.warnings}
        emptyMsg="Nessun warning attivo ✅"
      />

      <DataTable
        title={`🔕 Job Disabilitati — ${data.disabled?.length ?? 0}`}
        columns={SIMPLE_COLS}
        rows={data.disabled}
        emptyMsg="Nessun job disabilitato"
      />

      <DataTable
        title={`❌ Job che non hanno mai completato OK — ${data.never_ok?.length ?? 0}`}
        columns={SIMPLE_COLS}
        rows={data.never_ok}
        emptyMsg="Tutti i job hanno completato OK almeno una volta ✅"
      />
    </div>
  );
}
